import {
  Container,
  Grid,
  Typography,
  Box,
  FormGroup,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import React, { useState } from "react";
import classes from "../Styles/about.module.css";
import CloseIcon from "@mui/icons-material/Close";
import Project from "../Components/Project";
import projects from "../Assets/projects";
import classess from "../Styles/about.module.css";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { FaReact, FaHtml5 } from "react-icons/fa";
import { SiNestjs, SiExpress, SiNextdotjs } from "react-icons/si";
import { SiTailwindcss } from "react-icons/si";
import { SiFirebase } from "react-icons/si";
import { SiVite } from "react-icons/si";
import { SiMongodb } from "react-icons/si";

const Projects = () => {
  const [isPersonalOpen, setIsPersonal] = useState(true);
  const [state, setState] = useState({});

  const normalizeTag = (value) =>
    String(value).toLowerCase().replace(/\s+/g, "");
  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.checked,
    });
  };
  const applyFilters = projects.filter((item) => {
    if (Object.keys(state).length === 0) return true;
    if (Object.values(state).every((item) => !item)) return true;
    return Object.entries(state).some(
      ([key, value]) =>
        value &&
        item.lang.some((lang) => normalizeTag(lang) === normalizeTag(key)),
    );
  });

  return (
    <>
      <Container disableGutters maxWidth="100vw" className={classes.about_body}>
        <Grid container className={classes.grid_container}>
          <Grid item md={2} xs={12} className={classess.grid_item_inner}>
            <Grid
              item
              xs={12}
              sx={{
                display: { xs: "block", md: "none" },
                pl: { xs: 3, md: 0 },
                pb: { xs: 3, md: 0 },
                pt: 3,
                textAlign: "center",
              }}
            >
              <Typography className={classes.about_text}>_projects</Typography>
            </Grid>
            <Box
              onClick={() => setIsPersonal(!isPersonalOpen)}
              sx={{
                display: "flex",
                color: "white",
                width: "100%",
                borderBottom: "0.25px solid #1E2D3D",
                backgroundColor: { xs: "#1E2D3D", md: "transparent" },
                pt: 2,
                pb: 1,
                cursor: "pointer",
              }}
            >
              {isPersonalOpen ? <ArrowDropDownIcon /> : <ArrowRightIcon />}

              <Typography className={classess.about_text}>projects</Typography>
            </Box>
            <Box sx={{ display: isPersonalOpen ? "block" : "none" }}>
              <FormGroup>
                <FormControlLabel
                  sx={{
                    color: "white",
                    pl: 2,
                    fontFamily: " 'Fira Code', monospace !important",
                  }}
                  control={
                    <>
                      <Checkbox
                        onChange={(e) => handleChange(e)}
                        value="Next"
                        name="Next"
                        // checked={state}
                        sx={{ color: "#607B96" }}
                      />
                      <SiNextdotjs
                        style={{ color: "#607B96", paddingRight: "3%" }}
                      />
                    </>
                  }
                  label="Next JS"
                />
                <FormControlLabel
                  sx={{
                    color: "white",
                    pl: 2,
                    fontFamily: " 'Fira Code', monospace !important",
                  }}
                  control={
                    <>
                      <Checkbox
                        onChange={(e) => handleChange(e)}
                        value="Express"
                        name="Express"
                        // checked={state}
                        sx={{ color: "#607B96" }}
                      />
                      <SiExpress
                        style={{ color: "#607B96", paddingRight: "3%" }}
                      />
                    </>
                  }
                  label="Express JS"
                />
                <FormControlLabel
                  sx={{
                    color: "white",
                    pl: 2,
                    fontFamily: " 'Fira Code', monospace !important",
                  }}
                  control={
                    <>
                      <Checkbox
                        onChange={(e) => handleChange(e)}
                        value="Nest"
                        name="Nest"
                        // checked={state}
                        sx={{ color: "#607B96" }}
                      />
                      <SiNestjs
                        style={{ color: "#607B96", paddingRight: "3%" }}
                      />
                    </>
                  }
                  label="Nest JS"
                />

                <FormControlLabel
                  sx={{
                    color: "white",
                    pl: 2,
                    fontFamily: " 'Fira Code', monospace !important",
                  }}
                  control={
                    <>
                      <Checkbox
                        onChange={(e) => handleChange(e)}
                        value="React"
                        name="React"
                        // checked={state}
                        sx={{ color: "#607B96" }}
                      />
                      <FaReact
                        style={{ color: "#607B96", paddingRight: "3%" }}
                      />
                    </>
                  }
                  label="React JS"
                />
                <FormControlLabel
                  sx={{
                    color: "white",
                    pl: 2,
                    fontFamily: " 'Fira Code', monospace !important",
                  }}
                  control={
                    <>
                      <Checkbox
                        // checked={state}
                        onChange={handleChange}
                        value="HTML"
                        name="HTML"
                        sx={{ color: "#607B96" }}
                      />
                      <FaHtml5
                        style={{ color: "#607B96", paddingRight: "3%" }}
                      />
                    </>
                  }
                  label="HTML&CSS"
                />

                <FormControlLabel
                  sx={{
                    color: "white",
                    pl: 2,
                    fontFamily: " 'Fira Code', monospace !important",
                  }}
                  control={
                    <Checkbox
                      onChange={handleChange}
                      value="TypeScript"
                      name="TypeScript"
                      sx={{ color: "#607B96" }}
                    />
                  }
                  label="TypeScript"
                />
                <FormControlLabel
                  sx={{
                    color: "white",
                    pl: 2,
                    fontFamily: " 'Fira Code', monospace !important",
                  }}
                  control={
                    <>
                      <Checkbox
                        onChange={handleChange}
                        value="MongoDB"
                        name="MongoDB"
                        sx={{ color: "#607B96" }}
                      />
                      <SiMongodb
                        style={{ color: "#607B96", paddingRight: "3%" }}
                      />
                    </>
                  }
                  label="MongoDB"
                />
                <FormControlLabel
                  sx={{
                    color: "white",
                    pl: 2,
                    fontFamily: " 'Fira Code', monospace !important",
                  }}
                  control={
                    <>
                      <Checkbox
                        onChange={handleChange}
                        value="Tailwind"
                        name="Tailwind"
                        sx={{ color: "#607B96" }}
                      />
                      <SiTailwindcss
                        style={{ color: "#607B96", paddingRight: "3%" }}
                      />
                    </>
                  }
                  label="Tailwind"
                />
                <FormControlLabel
                  sx={{
                    color: "white",
                    pl: 2,
                    fontFamily: " 'Fira Code', monospace !important",
                  }}
                  control={
                    <>
                      <Checkbox
                        onChange={handleChange}
                        value="Mantine UI"
                        name="Mantine UI"
                        sx={{ color: "#607B96" }}
                      />
                      <FaReact
                        style={{ color: "#607B96", paddingRight: "3%" }}
                      />
                    </>
                  }
                  label="Mantine UI"
                />
                <FormControlLabel
                  sx={{
                    color: "white",
                    pl: 2,
                    fontFamily: " 'Fira Code', monospace !important",
                  }}
                  control={
                    <Checkbox
                      onChange={handleChange}
                      value="Material UI"
                      name="Material UI"
                      sx={{ color: "#607B96" }}
                    />
                  }
                  label="Material UI"
                />
                <FormControlLabel
                  sx={{
                    color: "white",
                    pl: 2,
                    fontFamily: " 'Fira Code', monospace !important",
                  }}
                  control={
                    <>
                      <Checkbox
                        onChange={handleChange}
                        value="Firebase"
                        name="Firebase"
                        sx={{ color: "#607B96" }}
                      />
                      <SiFirebase
                        style={{ color: "#607B96", paddingRight: "3%" }}
                      />
                    </>
                  }
                  label="Firebase"
                />
                <FormControlLabel
                  sx={{
                    color: "white",
                    pl: 2,
                    fontFamily: " 'Fira Code', monospace !important",
                  }}
                  control={
                    <>
                      <Checkbox
                        onChange={handleChange}
                        value="Vite"
                        name="Vite"
                        sx={{ color: "#607B96" }}
                      />
                      <SiVite
                        style={{ color: "#607B96", paddingRight: "3%" }}
                      />
                    </>
                  }
                  label="Vite"
                />
              </FormGroup>
            </Box>

            {/* prof */}
          </Grid>

          <Grid
            item
            md={10}
            sx={{ borderRight: { xs: "none", md: "0.25px solid #1E2D3D" } }}
          >
            <Box
              sx={{
                height: "100%",
              }}
              className={classes.about_overflow}
            >
              <Box
                sx={{
                  borderBottom: { xs: "none", md: "0.25px solid #1E2D3D" },
                }}
              >
                <Box sx={{ display: "flex" }}>
                  <Typography
                    sx={{
                      color: "#607B96",
                      borderRight: "0.25px solid #1E2D3D",
                      fontSize: "16px",
                      display: { xs: "none", md: "block" },
                      fontFamily: "'Fira Code', monospace !important",
                      pt: 1.4,
                      pb: 1,
                      pl: 2,
                    }}
                  >
                    {Object.keys(state).length === 0 ||
                    Object.values(state).every((item) => !item)
                      ? "all"
                      : Object.entries(state)
                          .filter(([key, value]) => value)
                          .map(([key, value]) => key)
                          .join(";")}
                    {/* {!state.React&&!state.HTML?"all"state.React && state.HTML ? "React; HTML" : "React"} */}
                    <CloseIcon
                      sx={{ fontSize: "18px", pt: 0.4, pl: 4, pr: 2 }}
                    />
                  </Typography>
                  <Typography
                    sx={{
                      color: "#FFFFFF",

                      fontSize: "16px",
                      display: { xs: "block", md: "none" },

                      fontFamily: "'Fira Code', monospace !important",
                      pt: 3,
                      pb: 1,
                      pl: 2,
                    }}
                  >
                    {`// projects`}
                  </Typography>
                </Box>
              </Box>

              <Grid container className={classes.project_container}>
                {applyFilters.map((proj, index) => {
                  return (
                    <Project
                      name={proj.name}
                      lang={proj.lang}
                      index={index + 1}
                      description={proj.description}
                      icon={proj.icon}
                      link={proj.link}
                      image={proj.pic}
                      type={proj.type}
                      // stateObj={state}
                    />
                  );
                })}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Projects;
